import React from 'react';
import * as deviceUtils from 'detect-mobile-device';
import cx from 'classnames';
import styles from '../tiny-input/index.less';
import wrapStore from '../../utils/wrap-store';
import TinyInputStore from '../tiny-input/store';

/**
 * 使用: <PhoneInput placeholder="请输入手机号" className="appointmentModal-layer-14" store={store.phoneInputStore} maxLength={11} />
 *
 * Android 端弹起数字键盘会带上#和*，适合输入电话。
 * IOS 端弹出纯数字
 * @param rest
 * @return {JSX.Element}
 * @constructor
 */
const PhoneInput = wrapStore(({ store, className, ...rest }) => {
  store.use();
  if (deviceUtils.isIOS()) {
    return (
      <input
        type="number"
        pattern="\d*"
        ref={store.elementRef}
        className={cx(className, styles.input)}
        value={store.value}
        onChange={store.onChange}
        {...rest}
      />
    );
  } else {
    return <input type="tel" ref={store.elementRef} className={cx(className, styles.input)} value={store.value} onChange={store.onChange} {...rest} />;
  }
}, TinyInputStore);

export default PhoneInput;
